






















import { biHT } from '@/business/bi';
import { updateRedDot } from '@/business/red-dot';
import { getActiveInfo, HeaderTabText, HeaderTabType, isHeaderTabPage } from '@/config/page-tab';
import { language } from '@tencent/ppd-base-libs';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Route } from 'vue-router';

type CountInfo = {
  [HeaderTabType.couponlist]: number | undefined;
  [HeaderTabType.displaycouponlist]: number | undefined;
};

type RedDotInfo = {
  [HeaderTabType.couponlist]: boolean;
  [HeaderTabType.displaycouponlist]: boolean;
};

type HeaderTabItem = { key: string; text: string };

@Component
export default class HeaderTab extends Vue {
  /** 是否展示tab */
  private isShow = false;
  /** tab会话级访问记录（不持久化） */
  private tabVisitedMap: Record<string, boolean> = {};
  @Prop() private redDotInfo!: RedDotInfo;
  @Prop() private countInfo!: CountInfo;

  private headerTabTextConfig = HeaderTabText as HeaderTabItem[];

  private get lang() {
    return language.getLang();
  }

  /** 当前激活的 tab：直接由 $route 派生，初始渲染即为正确值，避免先选中 couponlist 再切到 displaycouponlist 的闪现 */
  private get activeTab(): string {
    return getActiveInfo(this.$route).activeTab || '';
  }

  /** Tab 文案：名称(数量)；count 为 undefined 时降级为不带括号的名称 */
  public getTabText(item: HeaderTabItem) {
    const count = this.countInfo?.[item.key];
    if (typeof count === 'undefined') return item.text;
    return `${item.text}(${count})`;
  }

  /** 更新当前路由的红点（沿用旧入口，供 PageTab 兼容调用） */
  public updateCurrentRouteRedDot() {
    this.updateHeaderRedDot(this.$route.name);
  }

  @Watch('$route', { immediate: true })
  private handleRouteChange(to: Route, from: Route) {
    this.isShow = isHeaderTabPage(to);
    if (isHeaderTabPage(to)) {
      this.updateHeaderRedDot(from?.name);
      this.updateHeaderRedDot(to.name);
    }
  }

  @Watch('isShow')
  private handleIsShow() {
    if (this.isShow) {
      this.markTabVisited(this.activeTab);
      biHT('promozone.myasset.myassets_brow');
    }
  }

  private updateHeaderRedDot(key) {
    if (!key) return;
    if (this.redDotInfo?.[key]) {
      updateRedDot(key);
    }
    this.$emit('clearRedDot', { tab: 'header', key });
  }

  private onClickTab(key: string) {
    if (key === this.activeTab) return;
    biHT('promozone.myasset.subtab_click', {
      ftoptabid: HeaderTabType.couponlist,
      fsubtabid: key,
    });
    if (key === HeaderTabType.displaycouponlist) {
      this.$set(this.tabVisitedMap, HeaderTabType.displaycouponlist, true);
    }
    this.markTabVisited(key);
    this.$router.replace({ name: key, query: this.$route.query });
  }

  /**
   * 手动启用券左置小红点：后端红点 + 持有数量 + 本会话未访问 + 非当前 Tab，缺一不展示。
   * 其中 tabVisitedMap 用于切入后立即消失（不等接口刷新），spec §2.6。
   */
  private isShowLeftRedDot(tabKey: string) {
    if (tabKey !== HeaderTabType.displaycouponlist) return false;
    if (!this.redDotInfo?.[HeaderTabType.displaycouponlist]) return false;
    const count = this.countInfo?.[HeaderTabType.displaycouponlist];
    if (typeof count !== 'number' || count <= 0) return false;
    if (this.tabVisitedMap[HeaderTabType.displaycouponlist]) return false;
    if (this.activeTab === HeaderTabType.displaycouponlist) return false;
    return true;
  }

  private markTabVisited(tabKey: string) {
    const isTab = this.headerTabTextConfig.map(item => item.key).includes(tabKey);
    if (isTab) {
      this.$set(this.tabVisitedMap, tabKey, true);
    }
  }
}
